import { NextImage } from '@zurich-framework/nextapp/components';
import { useTranslation } from '@zurich/common/hooks';
import { Stack, Typography } from '@zurich/ui/atoms';
import { styled } from '@zurich/ui/legacy/utils';
import { Card } from '@zurich/ui/molecules';

export function MobileOnlyNotice() {
  const { t } = useTranslation();
  return (
    <Card title="">
      <Stack alignItems="center" justifyContent="flex-start" rowGap={3}>
        <Typography variant="h3" color="darkBlue" align="center">
          {t('common:mobileOnly')}
        </Typography>
        <NextImageStyled
          src="/images/mobilePhone.svg"
          alt="writing hand"
          width={300}
          height={300}
        />
      </Stack>
    </Card>
  );
}
const NextImageStyled = styled(NextImage)(({ theme }) => ({
  padding: theme.spacing(3),
}));
